import { Inject, injectable } from 'inversify-props';
import { BaseAPIService } from './base-api.service';
import { Customer } from '@/models/DTO/customer/customer.model';
import { CustomerUpdateRequest } from '@/models/DTO/customer/customer-update-request.model';

const API_VERSION: string = process.env.VUE_APP_API_VERSION;
const CUSTOMERS_STUB_URL = `/api/v${API_VERSION}/Customers`;
const CUSTOMERS_GET_BY_EMAIL_URL = `${CUSTOMERS_STUB_URL}/GetByEmail?email=`;

export interface CustomersService {
  getAllCustomers(): Promise<Customer[]>;
  getCustomerById(id: string): Promise<Customer>;
  getCustomerByEmail(email: string): Promise<Customer>;
  updateCustomer(model: CustomerUpdateRequest): Promise<Customer>;
}

@injectable()
export class CustomersService implements CustomersService {
  @Inject()
  private readonly _baseAPIService!: BaseAPIService;

  public async getAllCustomers(): Promise<Customer[]> {
    const resp = await this._baseAPIService.client.get<Customer[]>(
      CUSTOMERS_STUB_URL
    );
    return resp.data;
  }

  public async getCustomerById(id: string): Promise<Customer> {
    const resp = await this._baseAPIService.client.get<Customer>(
      CUSTOMERS_STUB_URL + `/${id}`
    );
    return resp.data;
  }

  public async getCustomerByEmail(email: string): Promise<Customer> {
    const encodedEmail = encodeURIComponent(email);

    const resp = await this._baseAPIService.client.get<Customer>(
      CUSTOMERS_GET_BY_EMAIL_URL + encodedEmail
    );

    return resp.data;
  }

  public async updateCustomer(model: CustomerUpdateRequest): Promise<Customer> {
    const resp = await this._baseAPIService.client.put<Customer>(
      CUSTOMERS_STUB_URL + `/${model.id}`,
      {
        ...model
      }
    );
    return resp.data;
  }
}
